// extracted by mini-css-extract-plugin
module.exports = {"alertIndex":"styles_alertIndex__10Cph","iconSize":"styles_iconSize__2etYv","messageHeight":"styles_messageHeight__3ISQb"};